export const ROUTE_PATH = '/clean/cleaner/signup' as const
